import { render, staticRenderFns } from "./RespostaFreteDialog.vue?vue&type=template&id=0b8729c6"
import script from "./RespostaFreteDialog.vue?vue&type=script&lang=js"
export * from "./RespostaFreteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports